import { render, staticRenderFns } from "./LoginNavbar.vue?vue&type=template&id=612e6948&scoped=true&"
var script = {}
import style0 from "./LoginNavbar.vue?vue&type=style&index=0&id=612e6948&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612e6948",
  null
  
)

export default component.exports